import React, { useEffect, useState } from "react";
import { Button, Link } from "@mui/material";
import AuthBoxHeader from "../../components/authentication/AuthBoxHeader";
import OTPInputMask from "../../components/authentication/OTPInputMask";
// import GoBack from "../../components/authentication/GoBack";
import AuthLayout from "src/layouts/AuthLayout";
import { useLocation, useNavigate } from "react-router";
import authStores from "../../contexts/AuthProvider";
import { useSnackbar } from "notistack";
import CountDownTimer from "src/components/common/CountDownTimer";

const OtpVerification = () => {
  const { enqueueSnackbar } = useSnackbar();
  const authStore = authStores();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [enteredOTP, setEnteredOTP] = useState({});
  const [showSubmitBtn, setShowSubmitBtn] = useState(false);
  const [otpString, setOtpString] = useState("");
  const [resendRequest, setResendRequest] = useState(false);
  const [time, setTime] = useState({ seconds: 30 });

  const handleUserOtpOnChange = (obj) => {
    setEnteredOTP(obj);
  };
  useEffect(() => {
    if (Object.keys(enteredOTP).filter((digit) => enteredOTP[digit] !== "").length === 4) {
      setShowSubmitBtn(true);
    } else {
      setShowSubmitBtn(false);
    }
  }, [enteredOTP]);
  const hanleNavigate = () => {
    navigate(-1);
  };
  useEffect(() => {
    if (enteredOTP[Object.keys(enteredOTP).filter((item) => item === "digit-4")] !== "") {
      setOtpString(enteredOTP["digit-1"] + enteredOTP["digit-2"] + enteredOTP["digit-3"] + enteredOTP["digit-4"]);
    }
  }, [enteredOTP]);

  // for varification
  const sendVerification = async (e) => {
    e.preventDefault();
    const otpObj = {
      otp: otpString,
      email: state.userEmail,
      device: 3,
    };

    const otpObject = {
      otp: otpString,
      email: state.userEmail,
      device: 3,
      reason: "twoFactorAuthentication",
    };

    // for two Factor verification
    if (state.reason === "twoFactorAuthentication") {
      // call api here
      const [success, error] = await authStore.twoFactorAuthentication(otpObject);
      if (success) {
        enqueueSnackbar("Verify Successfully", {
          variant: "success",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          autoHideDuration: 2500,
        });
        navigate("/dashboard/", { state: success });
        
      } else {
        if (error) {
          enqueueSnackbar(error, {
            variant: "error",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2500,
          });
        }
      }
    } else if (state?.verify === "forgetPassword") {
      const [success, error] = await authStore.verifyOtp(otpObj);
      if (success) {
        const tokenData = {
          token: success.token,
        };
        enqueueSnackbar("Verify Successfully", {
          variant: "success",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          autoHideDuration: 2500,
        });
        navigate("/reset-password", { state: tokenData });
      } else {
        enqueueSnackbar(error.message, {
          variant: "error",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          autoHideDuration: 2000,
        });
      }
    } else {
      const [success, error] = await authStore.signupVerifyOTP(otpObj);
      if (success) {
        
        enqueueSnackbar("Verify Successfully", {
          variant: "success",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          autoHideDuration: 2500,
        });
        // navigate('/kyc-upload', { state: state.userEmail });
        navigate("/thankyou",{state:"verificationSuccess"});
      } else {
        enqueueSnackbar(error, {
          variant: "error",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          autoHideDuration: 2000,
        });
      }
    }
  };

  // for resend otp
  const handleClick = async (e) => {
    e.preventDefault();
    setResendRequest(false);
    if (state.reason === "twoFactorAuthentication") {
      const resendOtpObject = {
        otp: otpString,
        email: state.userEmail,
        device: 3,
        reason: "twoFactorAuthentication",
      };
      // call api here
      const [success, error] = await authStore.resendTwoFactorOtp(resendOtpObject);
      if (error) {
        if (error.data.message === "check your email for otp.") {
          enqueueSnackbar("please Check your email for otp", {
            variant: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 1000,
          });
        }
      }
    } else if (state?.verify === "forgetPassword") {
      const resendOtpObj = {
        email: state.userEmail,
        device: 3,
        reason: "forForgetPassword",
      };
      const [success, error] = await authStore.resendOTP(resendOtpObj);
      if (success) {
        enqueueSnackbar(success, {
          variant: "success",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          autoHideDuration: 2000,
        });
      } else {
        enqueueSnackbar(error, {
          variant: "error",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          autoHideDuration: 2000,
        });
      }
    } else {
      const resendOtpObj = {
        email: state.userEmail,
        device: 3,
        reason: "forSignUp",
      };
      const [success, error] = await authStore.resendOTP(resendOtpObj);
      if (success) {
        enqueueSnackbar(success, {
          variant: "success",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          autoHideDuration: 2000,
        });
      } else {
        enqueueSnackbar(error, {
          variant: "error",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          autoHideDuration: 2000,
        });
      }
    }
  };

  return (
    <>
      <AuthLayout>
        <div className="auth_box">
          <AuthBoxHeader title={"OTP Verification"} instruction={`Thank you for registering your business on the Binox Bargains platform, please check your email for the one time passcode sent, then sign in to complete your business registration process `} />
          <OTPInputMask otpOnChangeFunc={handleUserOtpOnChange} />
          <div className="app_text_14 mb-5 d-flex app_text_transform">
            <span className="me-2">Didn’t receive a code?</span>
            {!resendRequest ? (
              <CountDownTimer hoursMinSecs={time} resendRequest={resendRequest} setResendRequest={setResendRequest} />
            ) : (
              <Link href="/" className="app_text_primary ms-2 text-decoration-underline app_text_14" onClick={handleClick}>
                Resend
              </Link>
            )}
          </div>
          {showSubmitBtn && (
            <Button fullWidth variant="contained"
              sx={{
                backgroundColor: "#FFBD05", boxShadow: "none", borderRadius: "8px", "&:hover": {
                backgroundColor: "#FFBD05",
                boxShadow: "none",
                }
              }}
              className="text-capitalize text-white  app_text_16_semibold app_btn_lg" onClick={sendVerification}>
              Verify
            </Button>
          )}
        </div>
      </AuthLayout>
    </>
  );
};

export default OtpVerification;
